module.exports = __webpack_public_path__ + "static/media/iconhxcf_icon_youjiantou_10_gray.52e297bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/iconhxcf_icon_youjiantou_10_gray.png
// module id = 1775
// module chunks = 0 1